import { render, staticRenderFns } from "./startAdditionalApprovals.vue?vue&type=template&id=0dc52019"
import script from "./startAdditionalApprovals.vue?vue&type=script&lang=js"
export * from "./startAdditionalApprovals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports